module.exports = __webpack_public_path__ + "img/onlineDrainage_pic.b93f6fe2.png";